"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRange = void 0;
var parseRange = function (rangeStr) {
    if (!rangeStr) {
        return undefined;
    }
    if (rangeStr.includes(",")) {
        var _a = rangeStr.split(","), minStr = _a[0], maxStr = _a[1];
        return [parseInt(minStr, 10), parseInt(maxStr, 10)];
    }
    return parseInt(rangeStr, 10);
};
exports.parseRange = parseRange;
